import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import V2Footer from "@Components/V2Footer/V2Footer";
// Navbar and Reveal are shared with About Us v2 rather than copied, so the v2 pages
// keep one source of truth for the scroll/hover interactions.
import Navbar from "@Components/Navbar/Navbar";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";
import Hero from "./components/Hero/Hero";
import Channels from "./components/Channels/Channels";
import styles from "./ContactUsV2.module.scss";
import { BLOG_URL, HOW_IT_WORKS_URL } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";

/**
 * Contact Us, photo + two-column channels variant.
 *
 * A third cut of /contact-us-v2. The original stacks a small label above each set of
 * channels in one narrow column; /contact-us-v2-alt lays them on the photo in a
 * panel. This one gives each group's name its own column at display size, with the
 * rows running down beside it, under a photo that carries nothing on top of it.
 *
 * Not the shared SupportChannels section: that one is the single-column cut. This
 * layout is local to this page so the two can be compared side by side.
 */
const ContactUsV2 = () => {
  const { t } = useTranslationHook();

  return (
    <div className={styles.page}>
      <Helmet title={t("contact.v2.meta.title")}>
        <meta name="description" content={t("contact.v2.meta.description")} />
        {/* Instrument Sans — the design font, loaded only on this page */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap"
        />
      </Helmet>

      <Navbar
        links={[
          { label: "navbar.v2.howitworks", href: HOW_IT_WORKS_URL },
          { label: "navbar.v2.blogs", href: BLOG_URL },
        ]}
      />
      <Hero />
      <Channels />
      <V2Footer />

      {/* The Copilot panel itself. The hero's docked input only DISPATCHES the open action — this is
        what listens for it and renders the side panel, and it also brings the floating Copilot
        button the rest of the site has. Both entry points open this one panel.
        Mounted last so it layers over the page, and lazily loaded inside, so nothing of the
        chatbot is fetched until it is actually opened. */}
      <AmberCopilotWrapper />
    </div>
  );
};

export default wrapperHOC(ContactUsV2, {
  componentName: "ContactUsV2-Page",
  showForChina: true,
});
